module.exports = "/images/destination-icon.svg?e61ffaa7fdf46014dd9d327bf62721ec";